module.exports = __webpack_public_path__ + "static/media/denison.48b91c97.PNG";